{
    "RecordingList_Column_Description": "Descrição",
    "RecordingList_Column_Type": "Tipo",
    "RecordingList_Column_TelSys": "Servidor de telefonia",
    "RecordingList_Column_Partition": "Partição",
    "RecordingList_Scope_All": "Todos",
    "RecordingList_Scope_ServiceWide": "Serviço em geral",
    "RecordingList_Scope_SystemWide": "Em todo o sistema",
    "RecordingList_Scope_Detached": "Desapegado",
    "RecordingList_Type_All": "Todos",
    "RecordingList_Type_Dubber": "Dubber",
    "RecordingList_Scope_Label": "Escopo",
    "RecordingList_Type_Label": "Tipo",
    "NAME": "Lista de gravações"
}